module.exports = __webpack_public_path__ + "img/12.a143d54f.svg";